'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jockey = require('./jockey');

var _jockey2 = _interopRequireDefault(_jockey);

var _events = require('./events');

var _events2 = _interopRequireDefault(_events);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ZenderError = function (_Error) {
	_inherits(ZenderError, _Error);

	function ZenderError(message) {
		_classCallCheck(this, ZenderError);

		var _this = _possibleConstructorReturn(this, (ZenderError.__proto__ || Object.getPrototypeOf(ZenderError)).call(this));

		_this.name = 'ZenderError';
		_this.message = message;
		return _this;
	}

	return ZenderError;
}(Error);

var Dispatcher = function () {
	function Dispatcher() {
		_classCallCheck(this, Dispatcher);

		this.callbacks = {};
	}

	_createClass(Dispatcher, [{
		key: 'on',
		value: function on(event, callback) {
			if (_events2.default[event]) {
				if (!this.callbacks[_events2.default[event]]) {
					this.callbacks[_events2.default[event]] = [];
				}
				this.callbacks[_events2.default[event]].push(callback);
				return this;
			}
			throw new ZenderError('You cannot bind to "' + event + '"!');
		}
	}, {
		key: 'trigger',
		value: function trigger(event, data) {
			this.dispatch(event, data);
			return this;
		}
	}, {
		key: 'dispatch',
		value: function dispatch(event, data) {
			var chain = this.callbacks[event];
			if (chain) {
				var results = [];
				var _iteratorNormalCompletion = true;
				var _didIteratorError = false;
				var _iteratorError = undefined;

				try {
					for (var _iterator = chain[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
						var callback = _step.value;

						results.push(callback(data));
					}
				} catch (err) {
					_didIteratorError = true;
					_iteratorError = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion && _iterator.return) {
							_iterator.return();
						}
					} finally {
						if (_didIteratorError) {
							throw _iteratorError;
						}
					}
				}

				return results;
			}
			return this;
		}
	}]);

	return Dispatcher;
}();

var Debug = function (_Dispatcher) {
	_inherits(Debug, _Dispatcher);

	function Debug(zender) {
		_classCallCheck(this, Debug);

		var _this2 = _possibleConstructorReturn(this, (Debug.__proto__ || Object.getPrototypeOf(Debug)).call(this));

		_this2.zender = zender;
		return _this2;
	}

	_createClass(Debug, [{
		key: 'playerLog',
		value: function playerLog(payload) {
			console.log('Triggering "' + _events2.default.player_log + '" event to HTML-app!', JSON.stringify({ payload: payload }));
			this.zender.trigger(_events2.default.player_log, payload);
		}
	}, {
		key: 'appDeactive',
		value: function appDeactive() {
			console.log('Triggering "' + _events2.default.app_deactive + '" event to HTML-app!');
			this.zender.trigger(_events2.default.app_deactive);
		}
	}, {
		key: 'appActive',
		value: function appActive() {
			console.log('Triggering "' + _events2.default.app_active + '" event to HTML-app!');
			this.zender.trigger(_events2.default.app_active);
		}
	}, {
		key: 'authenticate',
		value: function authenticate(payload) {
			console.log('Triggering "' + _events2.default.auth_authenticate + '" event to HTML-app!', JSON.stringify({ payload: payload }));
			this.zender.trigger(_events2.default.auth_authenticate, payload);
		}
	}, {
		key: 'keyboardWillShow',
		value: function keyboardWillShow() {
			console.log('Triggering "' + _events2.default.keyboard_will_show + '" event to HTML-app!');
			this.zender.trigger(_events2.default.keyboard_will_show);
		}
	}, {
		key: 'keyboardDidShow',
		value: function keyboardDidShow() {
			console.log('Triggering "' + _events2.default.keyboard_did_show + '" event to HTML-app!');
			this.zender.trigger(_events2.default.keyboard_did_show);
		}
	}, {
		key: 'keyboardWillHide',
		value: function keyboardWillHide() {
			console.log('Triggering "' + _events2.default.keyboard_will_hide + '" event to HTML-app!');
			this.zender.trigger(_events2.default.keyboard_will_hide);
		}
	}, {
		key: 'keyboardDidHide',
		value: function keyboardDidHide() {
			console.log('Triggering "' + _events2.default.keyboard_did_hide + '" event to HTML-app!');
			this.zender.trigger(_events2.default.keyboard_did_hide);
		}
	}, {
		key: 'deviceSetToken',
		value: function deviceSetToken(payload) {
			console.log('Triggering "' + _events2.default.device_settoken + '" event to HTML-app!');
			this.zender.trigger(_events2.default.device_settoken, payload);
		}
	}, {
		key: 'deviceRegister',
		value: function deviceRegister(payload) {
			console.log('Triggering "' + _events2.default.device_register + '" event to HTML-app!');
			this.zender.trigger(_events2.default.device_register, payload);
		}
	}, {
		key: 'deviceUnregister',
		value: function deviceUnregister(payload) {
			console.log('Triggering "' + _events2.default.device_unregister + '" event to HTML-app!');
			this.zender.trigger(_events2.default.device_unregister, payload);
		}
	}, {
		key: 'deviceSubscribe',
		value: function deviceSubscribe(payload) {
			console.log('Triggering "' + _events2.default.device_subscribe + '" event to HTML-app!');
			this.zender.trigger(_events2.default.device_subscribe, payload);
		}
	}, {
		key: 'deviceUnsubscribe',
		value: function deviceUnsubscribe(payload) {
			console.log('Triggering "' + _events2.default.device_unsubscribe + '" event to HTML-app!');
			this.zender.trigger(_events2.default.device_unsubscribe, payload);
		}
	}, {
		key: 'quizAnswer',
		value: function quizAnswer(payload) {
			console.log('Triggering "' + _events2.default.quiz_answer + '" event to HTML-app!', JSON.stringify({ payload: payload }));
			this.zender.trigger(_events2.default.quiz_answer, payload);
		}
	}, {
		key: 'quizQuestionRedeem',
		value: function quizQuestionRedeem(payload) {
			console.log('Triggering "' + _events2.default.quiz_question_redeem + '" event to HTML-app!', JSON.stringify({ payload: payload }));
			this.zender.trigger(_events2.default.quiz_question_redeem, payload);
		}
	}, {
		key: 'quizSetCode',
		value: function quizSetCode(payload) {
			console.log('Triggering "' + _events2.default.quiz_setcode + '" event to HTML-app!', JSON.stringify({ payload: payload }));
			this.zender.trigger(_events2.default.quiz_setcode, payload);
		}
	}, {
		key: 'shout',
		value: function shout(payload) {
			console.log('Triggering "' + _events2.default.shoutbox_shout + '" event to HTML-app!', JSON.stringify({ payload: payload }));
			this.zender.trigger(_events2.default.shoutbox_shout, payload);
		}
	}, {
		key: 'emojisTrigger',
		value: function emojisTrigger(payload) {
			console.log('Triggering "' + _events2.default.emojis_trigger + '" event to HTML-app!', JSON.stringify({ payload: payload }));
			this.zender.trigger(_events2.default.emojis_trigger, payload);
		}
	}, {
		key: 'avatarsTrigger',
		value: function avatarsTrigger(payload) {
			console.log('Triggering "' + _events2.default.avatars_trigger + '" event to HTML-app!', JSON.stringify({ payload: payload }));
			this.zender.trigger(_events2.default.avatars_trigger, payload);
		}
	}, {
		key: 'pollVote',
		value: function pollVote(payload) {
			console.log('Triggering "' + _events2.default.polls_vote + '" event to HTML-app!', JSON.stringify({ payload: payload }));
			this.zender.trigger(_events2.default.polls_vote, payload);
		}
	}, {
		key: 'triggerNotification',
		value: function triggerNotification(payload) {
			console.log('Triggering "' + _events2.default.ui_trigger_notification + '" event to HTML-app!', JSON.stringify({ payload: payload }));
			this.zender.trigger(_events2.default.ui_trigger_notification, payload);
		}
	}, {
		key: 'panelExpand',
		value: function panelExpand(payload) {
			console.log('Triggering "' + _events2.default.ui_panel_expand + '" event to HTML-app!', JSON.stringify({ payload: payload }));
			this.zender.trigger(_events2.default.ui_panel_expand, payload);
		}
	}, {
		key: 'panelCollapse',
		value: function panelCollapse(payload) {
			console.log('Triggering "' + _events2.default.ui_panel_collapse + '" event to HTML-app!', JSON.stringify({ payload: payload }));
			this.zender.trigger(_events2.default.ui_panel_collapse, payload);
		}
	}, {
		key: 'panelCollapseAll',
		value: function panelCollapseAll(payload) {
			console.log('Triggering "' + _events2.default.ui_panel_collapse_all + '" event to HTML-app!', JSON.stringify({ payload: payload }));
			this.zender.trigger(_events2.default.ui_panel_collapse_all, payload);
		}
	}, {
		key: 'buttonHide',
		value: function buttonHide(payload) {
			console.log('Triggering "' + _events2.default.ui_button_hide + '" event to HTML-app!', JSON.stringify({ payload: payload }));
			this.zender.trigger(_events2.default.ui_button_hide, payload);
		}
	}, {
		key: 'buttonShow',
		value: function buttonShow(payload) {
			console.log('Triggering "' + _events2.default.ui_button_show + '" event to HTML-app!', JSON.stringify({ payload: payload }));
			this.zender.trigger(_events2.default.ui_button_show, payload);
		}
	}]);

	return Debug;
}(Dispatcher);

var User = function () {
	function User(zender, attrs) {
		_classCallCheck(this, User);

		Object.assign(this, attrs);
		this.zender = zender;
	}

	_createClass(User, [{
		key: 'init',
		value: function init(payload, cb) {
			console.log('Sending "' + _events2.default.auth_init + '" event to native!', JSON.stringify({ payload: payload }));
			if (this.zender.native) {
				_jockey2.default.send(_events2.default.auth_init, payload, cb);
			} else if (cb) {
				cb();
			}
		}
	}, {
		key: 'authRequired',
		value: function authRequired(payload, cb) {
			console.log('Sending "' + _events2.default.auth_required + '" event to native!', JSON.stringify({ payload: payload }));
			if (this.zender.native) {
				_jockey2.default.send(_events2.default.auth_required, payload, cb);
			} else if (cb) {
				cb();
			}
		}
	}, {
		key: 'authLogout',
		value: function authLogout(payload, cb) {
			console.log('Sending "' + _events2.default.auth_logout + '" event to native!', JSON.stringify({ payload: payload }));
			if (this.zender.native) {
				_jockey2.default.send(_events2.default.auth_logout, payload, cb);
			} else if (cb) {
				cb();
			}
		}
	}, {
		key: 'authSuccess',
		value: function authSuccess(payload, cb) {
			console.log('Sending "' + _events2.default.auth_success + '" event to native!', JSON.stringify({ payload: payload }));
			if (this.zender.native) {
				_jockey2.default.send(_events2.default.auth_success, payload, cb);
			} else if (cb) {
				cb();
			}
		}
	}, {
		key: 'authFail',
		value: function authFail(payload, cb) {
			console.log('Sending "' + _events2.default.auth_fail + '" event to native!', JSON.stringify({ payload: payload }));
			if (this.zender.native) {
				_jockey2.default.send(_events2.default.auth_fail, payload, cb);
			} else if (cb) {
				cb();
			}
		}
	}]);

	return User;
}();

var Media = function () {
	function Media(zender, attrs) {
		_classCallCheck(this, Media);

		Object.assign(this, attrs);
		this.zender = zender;
	}

	_createClass(Media, [{
		key: 'init',
		value: function init(payload, cb) {
			console.log('Sending "' + _events2.default.media_init + '" event to native!', JSON.stringify({ payload: payload }));
			if (this.zender.native) {
				_jockey2.default.send(_events2.default.media_init, payload, cb);
			} else if (cb) {
				cb();
			}
		}
	}, {
		key: 'update',
		value: function update(payload, cb) {
			console.log('Sending "' + _events2.default.media_update + '" event to native!', JSON.stringify({ payload: payload }));
			if (this.zender.native) {
				_jockey2.default.send(_events2.default.media_update, payload, cb);
			} else if (cb) {
				cb();
			}
		}
	}, {
		key: 'delete',
		value: function _delete(payload, cb) {
			console.log('Sending "' + _events2.default.media_delete + '" event to native!', JSON.stringify({ payload: payload }));
			if (this.zender.native) {
				_jockey2.default.send(_events2.default.media_delete, payload, cb);
			} else if (cb) {
				cb();
			}
		}
	}, {
		key: 'play',
		value: function play(payload, cb) {
			console.log('Sending "' + _events2.default.media_play + '" event to native!', JSON.stringify({ payload: payload }));
			if (this.zender.native) {
				_jockey2.default.send(_events2.default.media_play, payload, cb);
			} else if (cb) {
				cb();
			}
		}
	}]);

	return Media;
}();

var Quiz = function () {
	function Quiz(zender, attrs) {
		_classCallCheck(this, Quiz);

		Object.assign(this, attrs);
		this.zender = zender;
	}

	_createClass(Quiz, [{
		key: 'init',
		value: function init(payload, cb) {
			console.log('Sending "' + _events2.default.quiz_init + '" event to native!', JSON.stringify({ payload: payload }));
			if (this.zender.native) {
				_jockey2.default.send(_events2.default.quiz_init, payload, cb);
			} else if (cb) {
				cb();
			}
		}
	}, {
		key: 'start',
		value: function start(payload, cb) {
			console.log('Sending "' + _events2.default.quiz_start + '" event to native!', JSON.stringify({ payload: payload }));
			if (this.zender.native) {
				_jockey2.default.send(_events2.default.quiz_start, payload, cb);
			} else if (cb) {
				cb();
			}
		}
	}, {
		key: 'stop',
		value: function stop(payload, cb) {
			console.log('Sending "' + _events2.default.quiz_stop + '" event to native!', JSON.stringify({ payload: payload }));
			if (this.zender.native) {
				_jockey2.default.send(_events2.default.quiz_stop, payload, cb);
			} else if (cb) {
				cb();
			}
		}
	}, {
		key: 'question',
		value: function question(payload, cb) {
			console.log('Sending "' + _events2.default.quiz_question + '" event to native!', JSON.stringify({ payload: payload }));
			if (this.zender.native) {
				_jockey2.default.send(_events2.default.quiz_question, payload, cb);
			} else if (cb) {
				cb();
			}
		}
	}, {
		key: 'questionResults',
		value: function questionResults(payload, cb) {
			console.log('Sending "' + _events2.default.quiz_question_results + '" event to native!', JSON.stringify({ payload: payload }));
			if (this.zender.native) {
				_jockey2.default.send(_events2.default.quiz_question_results, payload, cb);
			} else if (cb) {
				cb();
			}
		}
	}, {
		key: 'answerCorrect',
		value: function answerCorrect(payload, cb) {
			console.log('Sending "' + _events2.default.quiz_answer_correct + '" event to native!', JSON.stringify({ payload: payload }));
			if (this.zender.native) {
				_jockey2.default.send(_events2.default.quiz_answer_correct, payload, cb);
			} else if (cb) {
				cb();
			}
		}
	}, {
		key: 'answerIncorrect',
		value: function answerIncorrect(payload, cb) {
			console.log('Sending "' + _events2.default.quiz_answer_incorrect + '" event to native!', JSON.stringify({ payload: payload }));
			if (this.zender.native) {
				_jockey2.default.send(_events2.default.quiz_answer_incorrect, payload, cb);
			} else if (cb) {
				cb();
			}
		}
	}, {
		key: 'useExtralife',
		value: function useExtralife(payload, cb) {
			console.log('Sending "' + _events2.default.quiz_extralife_use + '" event to native!', JSON.stringify({ payload: payload }));
			if (this.zender.native) {
				_jockey2.default.send(_events2.default.quiz_extralife_use, payload, cb);
			} else if (cb) {
				cb();
			}
		}
	}, {
		key: 'ignoreExtralife',
		value: function ignoreExtralife(payload, cb) {
			console.log('Sending "' + _events2.default.quiz_extralife_ignore + '" event to native!', JSON.stringify({ payload: payload }));
			if (this.zender.native) {
				_jockey2.default.send(_events2.default.quiz_extralife_ignore, payload, cb);
			} else if (cb) {
				cb();
			}
		}
	}, {
		key: 'submitAnswer',
		value: function submitAnswer(payload, cb) {
			console.log('Sending "' + _events2.default.quiz_answer_submit + '" event to native!', JSON.stringify({ payload: payload }));
			if (this.zender.native) {
				_jockey2.default.send(_events2.default.quiz_answer_submit, payload, cb);
			} else if (cb) {
				cb();
			}
		}
	}, {
		key: 'timeoutAnswer',
		value: function timeoutAnswer(payload, cb) {
			console.log('Sending "' + _events2.default.quiz_answer_timeout + '" event to native!', JSON.stringify({ payload: payload }));
			if (this.zender.native) {
				_jockey2.default.send(_events2.default.quiz_answer_timeout, payload, cb);
			} else if (cb) {
				cb();
			}
		}
	}, {
		key: 'eliminated',
		value: function eliminated(payload, cb) {
			console.log('Sending "' + _events2.default.quiz_eliminated + '" event to native!', JSON.stringify({ payload: payload }));
			if (this.zender.native) {
				_jockey2.default.send(_events2.default.quiz_eliminated, payload, cb);
			} else if (cb) {
				cb();
			}
		}
	}, {
		key: 'continueAfterEliminated',
		value: function continueAfterEliminated(payload, cb) {
			console.log('Sending "' + _events2.default.quiz_eliminated_continue + '" event to native!', JSON.stringify({ payload: payload }));
			if (this.zender.native) {
				_jockey2.default.send(_events2.default.quiz_eliminated_continue, payload, cb);
			} else if (cb) {
				cb();
			}
		}
	}, {
		key: 'results',
		value: function results(payload, cb) {
			console.log('Sending "' + _events2.default.quiz_results + '" event to native!', JSON.stringify({ payload: payload }));
			if (this.zender.native) {
				_jockey2.default.send(_events2.default.quiz_results, payload, cb);
			} else if (cb) {
				cb();
			}
		}
	}, {
		key: 'winner',
		value: function winner(payload, cb) {
			console.log('Sending "' + _events2.default.quiz_winner + '" event to native!', JSON.stringify({ payload: payload }));
			if (this.zender.native) {
				_jockey2.default.send(_events2.default.quiz_winner, payload, cb);
			} else if (cb) {
				cb();
			}
		}
	}, {
		key: 'loser',
		value: function loser(payload, cb) {
			console.log('Sending "' + _events2.default.quiz_loser + '" event to native!', JSON.stringify({ payload: payload }));
			if (this.zender.native) {
				_jockey2.default.send(_events2.default.quiz_loser, payload, cb);
			} else if (cb) {
				cb();
			}
		}
	}, {
		key: 'reset',
		value: function reset(payload, cb) {
			console.log('Sending "' + _events2.default.quiz_reset + '" event to native!', JSON.stringify({ payload: payload }));
			if (this.zender.native) {
				_jockey2.default.send(_events2.default.quiz_reset, payload, cb);
			} else if (cb) {
				cb();
			}
		}
	}, {
		key: 'delete',
		value: function _delete(payload, cb) {
			console.log('Sending "' + _events2.default.quiz_delete + '" event to native!', JSON.stringify({ payload: payload }));
			if (this.zender.native) {
				_jockey2.default.send(_events2.default.quiz_delete, payload, cb);
			} else if (cb) {
				cb();
			}
		}
	}, {
		key: 'shareCode',
		value: function shareCode(payload, cb) {
			console.log('Sending "' + _events2.default.quiz_share_code + '" event to native!', JSON.stringify({ payload: payload }));
			if (this.zender.native) {
				_jockey2.default.send(_events2.default.quiz_share_code, payload, cb);
			} else if (cb) {
				cb();
			}
		}
	}]);

	return Quiz;
}();

var Team = function () {
	function Team(zender, attrs) {
		_classCallCheck(this, Team);

		Object.assign(this, attrs);
		this.zender = zender;
	}

	_createClass(Team, [{
		key: 'init',
		value: function init(payload, cb) {
			console.log('Sending "' + _events2.default.team_init + '" event to native!', JSON.stringify({ payload: payload }));
			if (this.zender.native) {
				_jockey2.default.send(_events2.default.team_init, payload, cb);
			} else if (cb) {
				cb();
			}
		}
	}, {
		key: 'shareCode',
		value: function shareCode(payload, cb) {
			console.log('Sending "' + _events2.default.team_share_code + '" event to native!', JSON.stringify({ payload: payload }));
			if (this.zender.native) {
				_jockey2.default.send(_events2.default.team_share_code, payload, cb);
			} else if (cb) {
				cb();
			}
		}
	}]);

	return Team;
}();

var Targets = function () {
	function Targets(zender, attrs) {
		_classCallCheck(this, Targets);

		Object.assign(this, attrs);
		this.zender = zender;
	}

	_createClass(Targets, [{
		key: 'init',
		value: function init(payload, cb) {
			console.log('Sending "' + _events2.default.targets_init + '" event to native!', JSON.stringify({ payload: payload }));
			if (this.zender.native) {
				_jockey2.default.send(_events2.default.targets_init, payload, cb);
			} else if (cb) {
				cb();
			}
		}
	}]);

	return Targets;
}();

var Channels = function () {
	function Channels(zender, attrs) {
		_classCallCheck(this, Channels);

		Object.assign(this, attrs);
		this.zender = zender;
	}

	_createClass(Channels, [{
		key: 'init',
		value: function init(payload, cb) {
			console.log('Sending "' + _events2.default.channels_streams_init + '" event to native!', JSON.stringify({ payload: payload }));
			if (this.zender.native) {
				_jockey2.default.send(_events2.default.channels_streams_init, payload, cb);
			} else if (cb) {
				cb();
			}
		}
	}, {
		key: 'streamsPublish',
		value: function streamsPublish(payload, cb) {
			console.log('Sending "' + _events2.default.channels_streams_publish + '" event to native!', JSON.stringify({ payload: payload }));
			if (this.zender.native) {
				_jockey2.default.send(_events2.default.channels_streams_publish, payload, cb);
			} else if (cb) {
				cb();
			}
		}
	}, {
		key: 'streamsUnpublish',
		value: function streamsUnpublish(payload, cb) {
			console.log('Sending "' + _events2.default.channels_streams_unpublish + '" event to native!', JSON.stringify({ payload: payload }));
			if (this.zender.native) {
				_jockey2.default.send(_events2.default.channels_streams_unpublish, payload, cb);
			} else if (cb) {
				cb();
			}
		}
	}]);

	return Channels;
}();

var Streams = function () {
	function Streams(zender, attrs) {
		_classCallCheck(this, Streams);

		Object.assign(this, attrs);
		this.zender = zender;
	}

	_createClass(Streams, [{
		key: 'init',
		value: function init(payload, cb) {
			console.log('Sending "' + _events2.default.streams_init + '" event to native!', JSON.stringify({ payload: payload }));
			if (this.zender.native) {
				_jockey2.default.send(_events2.default.streams_init, payload, cb);
			} else if (cb) {
				cb();
			}
		}
	}, {
		key: 'update',
		value: function update(payload, cb) {
			console.log('Sending "' + _events2.default.streams_update + '" event to native!', JSON.stringify({ payload: payload }));
			if (this.zender.native) {
				_jockey2.default.send(_events2.default.streams_update, payload, cb);
			} else if (cb) {
				cb();
			}
		}
	}, {
		key: 'unpublish',
		value: function unpublish(payload, cb) {
			console.log('Sending "' + _events2.default.streams_unpublish + '" event to native!', JSON.stringify({ payload: payload }));
			if (this.zender.native) {
				_jockey2.default.send(_events2.default.streams_unpublish, payload, cb);
			} else if (cb) {
				cb();
			}
		}
	}, {
		key: 'stats',
		value: function stats(payload, cb) {
			console.log('Sending "' + _events2.default.streams_stats + '" event to native!', JSON.stringify({ payload: payload }));
			if (this.zender.native) {
				_jockey2.default.send(_events2.default.streams_stats, payload, cb);
			} else if (cb) {
				cb();
			}
		}
	}]);

	return Streams;
}();

var Emojis = function () {
	function Emojis(zender, attrs) {
		_classCallCheck(this, Emojis);

		Object.assign(this, attrs);
		this.zender = zender;
	}

	_createClass(Emojis, [{
		key: 'init',
		value: function init(payload, cb) {
			console.log('Sending "' + _events2.default.emojis_init + '" event to native!', JSON.stringify({ payload: payload }));
			if (this.zender.native) {
				_jockey2.default.send(_events2.default.emojis_init, payload, cb);
			} else if (cb) {
				cb();
			}
		}
	}, {
		key: 'update',
		value: function update(payload, cb) {
			console.log('Sending "' + _events2.default.emojis_update + '" event to native!', JSON.stringify({ payload: payload }));
			if (this.zender.native) {
				_jockey2.default.send(_events2.default.emojis_update, payload, cb);
			} else if (cb) {
				cb();
			}
		}
	}, {
		key: 'emojisStats',
		value: function emojisStats(payload, cb) {
			console.log('Sending "' + _events2.default.emojis_stats + '" event to native!', JSON.stringify({ payload: payload }));
			if (this.zender.native) {
				_jockey2.default.send(_events2.default.emojis_stats, payload, cb);
			} else if (cb) {
				cb();
			}
		}
	}, {
		key: 'avatarsStats',
		value: function avatarsStats(payload, cb) {
			console.log('Sending "' + _events2.default.avatars_stats + '" event to native!', JSON.stringify({ payload: payload }));
			if (this.zender.native) {
				_jockey2.default.send(_events2.default.avatars_stats, payload, cb);
			} else if (cb) {
				cb();
			}
		}
	}]);

	return Emojis;
}();

var Shoutbox = function () {
	function Shoutbox(zender, attrs) {
		_classCallCheck(this, Shoutbox);

		Object.assign(this, attrs);
		this.zender = zender;
	}

	_createClass(Shoutbox, [{
		key: 'init',
		value: function init(payload, cb) {
			console.log('Sending "' + _events2.default.shoutbox_init + '" event to native!', JSON.stringify({ payload: payload }));
			if (this.zender.native) {
				_jockey2.default.send(_events2.default.shoutbox_init, payload, cb);
			} else if (cb) {
				cb();
			}
		}
	}, {
		key: 'update',
		value: function update(payload, cb) {
			console.log('Sending "' + _events2.default.shoutbox_update + '" event to native!', JSON.stringify({ payload: payload }));
			if (this.zender.native) {
				_jockey2.default.send(_events2.default.shoutbox_update, payload, cb);
			} else if (cb) {
				cb();
			}
		}
	}, {
		key: 'shouts',
		value: function shouts(payload, cb) {
			console.log('Sending "' + _events2.default.shoutbox_shouts + '" event to native!', JSON.stringify({ payload: payload }));
			if (this.zender.native) {
				_jockey2.default.send(_events2.default.shoutbox_shouts, payload, cb);
			} else if (cb) {
				cb();
			}
		}
	}, {
		key: 'sentShout',
		value: function sentShout(payload, cb) {
			console.log('Sending "' + _events2.default.shoutbox_shout_send + '" event to native!', JSON.stringify({ payload: payload }));
			if (this.zender.native) {
				_jockey2.default.send(_events2.default.shoutbox_shout_send, payload, cb);
			} else if (cb) {
				cb();
			}
		}
	}, {
		key: 'replies',
		value: function replies(payload, cb) {
			console.log('Sending "' + _events2.default.shoutbox_replies + '" event to native!', JSON.stringify({ payload: payload }));
			if (this.zender.native) {
				_jockey2.default.send(_events2.default.shoutbox_replies, payload, cb);
			} else if (cb) {
				cb();
			}
		}
	}, {
		key: 'deleteShouts',
		value: function deleteShouts(payload, cb) {
			console.log('Sending "' + _events2.default.shoutbox_shouts_delete + '" event to native!', JSON.stringify({ payload: payload }));
			if (this.zender.native) {
				_jockey2.default.send(_events2.default.shoutbox_shouts_delete, payload, cb);
			} else if (cb) {
				cb();
			}
		}
	}]);

	return Shoutbox;
}();

var Polls = function () {
	function Polls(zender, attrs) {
		_classCallCheck(this, Polls);

		Object.assign(this, attrs);
		this.zender = zender;
	}

	_createClass(Polls, [{
		key: 'init',
		value: function init(payload, cb) {
			console.log('Sending "' + _events2.default.polls_init + '" event to native!', JSON.stringify({ payload: payload }));
			if (this.zender.native) {
				_jockey2.default.send(_events2.default.polls_init, payload, cb);
			} else if (cb) {
				cb();
			}
		}
	}, {
		key: 'update',
		value: function update(payload, cb) {
			console.log('Sending "' + _events2.default.polls_update + '" event to native!', JSON.stringify({ payload: payload }));
			if (this.zender.native) {
				_jockey2.default.send(_events2.default.polls_update, payload, cb);
			} else if (cb) {
				cb();
			}
		}
	}, {
		key: 'results',
		value: function results(payload, cb) {
			console.log('Sending "' + _events2.default.polls_results + '" event to native!', JSON.stringify({ payload: payload }));
			if (this.zender.native) {
				_jockey2.default.send(_events2.default.polls_results, payload, cb);
			} else if (cb) {
				cb();
			}
		}
	}, {
		key: 'animateResults',
		value: function animateResults(payload, cb) {
			console.log('Sending "' + _events2.default.polls_results_animate + '" event to native!', JSON.stringify({ payload: payload }));
			if (this.zender.native) {
				_jockey2.default.send(_events2.default.polls_results_animate, payload, cb);
			} else if (cb) {
				cb();
			}
		}
	}, {
		key: 'reset',
		value: function reset(payload, cb) {
			console.log('Sending "' + _events2.default.polls_reset + '" event to native!', JSON.stringify({ payload: payload }));
			if (this.zender.native) {
				_jockey2.default.send(_events2.default.polls_reset, payload, cb);
			} else if (cb) {
				cb();
			}
		}
	}, {
		key: 'delete',
		value: function _delete(payload, cb) {
			console.log('Sending "' + _events2.default.polls_delete + '" event to native!', JSON.stringify({ payload: payload }));
			if (this.zender.native) {
				_jockey2.default.send(_events2.default.polls_delete, payload, cb);
			} else if (cb) {
				cb();
			}
		}
	}]);

	return Polls;
}();

var UI = function UI(zender, attrs) {
	_classCallCheck(this, UI);

	this.streamsOverview = function (payload, cb) {
		console.log('Sending "' + _events2.default.ui_streams_overview + '" event to native!', JSON.stringify({ payload: payload }));
		_jockey2.default.send(_events2.default.ui_streams_overview, payload, function () {});
		if (cb) {
			cb();
		}
	};

	Object.assign(this, attrs);
	this.zender = zender;
};

var Player = function () {
	function Player(zender, attrs) {
		_classCallCheck(this, Player);

		this.close = function (payload, cb) {
			console.log('Sending "' + _events2.default.player_close + '" event to native:', JSON.stringify({ payload: payload }));
			_jockey2.default.send(_events2.default.player_close, { payload: payload }, function () {});
			if (cb) {
				cb();
			}
		};

		Object.assign(this, attrs);
		this.zender = zender;
	}

	_createClass(Player, [{
		key: 'ready',
		value: function ready(cb) {
			console.log('Sending "' + _events2.default.player_ready + '" event to native!');
			if (this.zender.native) {
				_jockey2.default.send(_events2.default.player_ready, function () {
					console.log('### Inside jockey cb for event ' + _events2.default.player_ready + ' ###');
					cb();
				});
			} else if (cb) {
				cb();
			}
		}
	}, {
		key: 'fail',
		value: function fail(failure, cb) {
			console.log('Sending "' + _events2.default.player_fail + '" event to native:', JSON.stringify({ failure: failure }));
			if (this.zender.native) {
				_jockey2.default.send(_events2.default.player_fail, { failure: failure }, cb);
			} else if (cb) {
				cb();
			}
		}
	}, {
		key: 'lobbyEnter',
		value: function lobbyEnter(payload, cb) {
			console.log('Sending "' + _events2.default.player_lobby_enter + '" event to native:', JSON.stringify({ payload: payload }));
			if (this.zender.native) {
				_jockey2.default.send(_events2.default.player_lobby_enter, { payload: payload }, cb);
			} else if (cb) {
				cb();
			}
		}
	}, {
		key: 'lobbyLeave',
		value: function lobbyLeave(payload, cb) {
			console.log('Sending "' + _events2.default.player_lobby_leave + '" event to native:', JSON.stringify({ payload: payload }));
			if (this.zender.native) {
				_jockey2.default.send(_events2.default.player_lobby_leave, { payload: payload }, cb);
			} else if (cb) {
				cb();
			}
		}
	}, {
		key: 'send',
		value: function send(type, payload, cb) {
			console.log('Sending generic event "%j" to native: %j!', JSON.stringify({ type: type, payload: payload }));
			if (this.native) {
				_jockey2.default.send('zender:' + type, payload, cb);
			} else if (cb) {
				cb();
			}
		}
	}]);

	return Player;
}();

var Env = function Env(zender, attrs) {
	_classCallCheck(this, Env);

	Object.assign(this, attrs);
	this.zender = zender;
};

var Params = function Params(zender, attrs) {
	_classCallCheck(this, Params);

	Object.assign(this, attrs);
	this.zender = zender;
};

var Utils = function () {
	function Utils(zender) {
		_classCallCheck(this, Utils);

		this.zender = zender;
	}

	_createClass(Utils, [{
		key: 'deepLink',
		value: function deepLink(link, cb) {
			console.log('Sending "' + _events2.default.deep_link + '" event to native!', JSON.stringify({ link: link }));
			if (this.zender.native) {
				_jockey2.default.send(_events2.default.deep_link, { link: link }, cb);
			} else if (cb) {
				cb();
			}
		}
	}, {
		key: 'openUrl',
		value: function openUrl(payload, cb) {
			console.log('Sending "' + _events2.default.open_url + '" event to native!', JSON.stringify({ payload: payload }));
			if (this.zender.native) {
				_jockey2.default.send(_events2.default.open_url, payload, cb);
			} else if (cb) {
				cb();
			}
		}
	}, {
		key: 'share',
		value: function share(payload, cb) {
			console.log('Sending "' + _events2.default.share + '" event to native!', JSON.stringify({ payload: payload }));
			if (this.zender.native) {
				_jockey2.default.send(_events2.default.share, payload, cb);
			} else if (cb) {
				cb();
			}
		}
	}]);

	return Utils;
}();

var Zender = function (_Dispatcher2) {
	_inherits(Zender, _Dispatcher2);

	function Zender() {
		_classCallCheck(this, Zender);

		var _this3 = _possibleConstructorReturn(this, (Zender.__proto__ || Object.getPrototypeOf(Zender)).call(this));

		_this3.utils = new Utils(_this3);
		_this3.debug = new Debug(_this3);
		_this3.player = new Player(_this3, {});
		_this3.user = new User(_this3, {});
		_this3.targets = new Targets(_this3, {});
		_this3.channels = new Channels(_this3, {});
		_this3.streams = new Streams(_this3, {});
		_this3.media = new Media(_this3, {});
		_this3.emojis = new Emojis(_this3, {});
		_this3.polls = new Polls(_this3, {});
		_this3.shoutbox = new Shoutbox(_this3, {});
		_this3.quiz = new Quiz(_this3, {});
		_this3.team = new Team(_this3, {});
		_this3.ui = new UI(_this3, {});
		_this3.env = new Env(_this3, {});
		_this3.jockey = _jockey2.default;
		return _this3;
	}

	// DEPRECATED: use initialize in stead


	_createClass(Zender, [{
		key: 'initializeNative',
		value: function initializeNative(readyPayload, cb) {
			var _this4 = this;

			this.native = true;
			var initPayload = this.initializePayload.bind(this);
			_jockey2.default.on(_events2.default.ready, initPayload);
			_jockey2.default.on(_events2.default.auth_authenticate, function (payload) {
				console.log('Sending "' + _events2.default.auth_authenticate + '" event to HTML-app!', payload);
				_this4.user = new User(_this4, payload.user);
				_this4.trigger(_events2.default.auth_authenticate, payload);
			});
			_jockey2.default.on(_events2.default.app_active, function (payload) {
				console.log('Sending "' + _events2.default.app_active + '" event to HTML-app!', payload);
				_this4.trigger(_events2.default.app_active, payload);
			});
			_jockey2.default.on(_events2.default.app_deactive, function (payload) {
				console.log('Sending "' + _events2.default.app_deactive + '" event to HTML-app!', payload);
				_this4.trigger(_events2.default.app_deactive, payload);
			});
			_jockey2.default.on(_events2.default.keyboard_will_show, function (payload) {
				console.log('Sending "' + _events2.default.keyboard_will_show + '" event to HTML-app!', payload);
				_this4.trigger(_events2.default.keyboard_will_show, payload);
			});
			_jockey2.default.on(_events2.default.keyboard_did_show, function (payload) {
				console.log('Sending "' + _events2.default.keyboard_did_show + '" event to HTML-app!', payload);
				_this4.trigger(_events2.default.keyboard_did_show, payload);
			});
			_jockey2.default.on(_events2.default.keyboard_will_hide, function (payload) {
				console.log('Sending "' + _events2.default.keyboard_will_hide + '" event to HTML-app!', payload);
				_this4.trigger(_events2.default.keyboard_will_hide, payload);
			});
			_jockey2.default.on(_events2.default.keyboard_did_hide, function (payload) {
				console.log('Sending "' + _events2.default.keyboard_did_hide + '" event to HTML-app!', payload);
				_this4.trigger(_events2.default.keyboard_did_hide, payload);
			});
			_jockey2.default.on(_events2.default.shoutbox_shout, function (payload) {
				console.log('Sending "' + _events2.default.shoutbox_shout + '" event to HTML-app!', payload);
				_this4.trigger(_events2.default.shoutbox_shout, payload);
			});
			_jockey2.default.on(_events2.default.emojis_trigger, function (payload) {
				console.log('Sending "' + _events2.default.emojis_trigger + '" event to HTML-app!', payload);
				_this4.trigger(_events2.default.emojis_trigger, payload);
			});
			_jockey2.default.on(_events2.default.avatars_trigger, function (payload) {
				console.log('Sending "' + _events2.default.avatars_trigger + '" event to HTML-app!', payload);
				_this4.trigger(_events2.default.avatars_trigger, payload);
			});
			_jockey2.default.on(_events2.default.quiz_answer, function (payload) {
				console.log('Sending "' + _events2.default.quiz_answer + '" event to HTML-app!', payload);
				_this4.trigger(_events2.default.quiz_answer, payload);
			});
			_jockey2.default.on(_events2.default.quiz_question_redeem, function (payload) {
				console.log('Sending "' + _events2.default.quiz_question_redeem + '" event to HTML-app!', payload);
				_this4.trigger(_events2.default.quiz_question_redeem, payload);
			});
			_jockey2.default.on(_events2.default.quiz_setcode, function (payload) {
				console.log('Sending "' + _events2.default.quiz_setcode + '" event to HTML-app!', payload);
				_this4.trigger(_events2.default.quiz_setcode, payload);
			});
			_jockey2.default.on(_events2.default.polls_vote, function (payload) {
				console.log('Sending "' + _events2.default.polls_vote + '" event to HTML-app!', payload);
				_this4.trigger(_events2.default.polls_vote, payload);
			});
			console.log('Sending "' + _events2.default.ready + '" event from zender-js to native:', JSON.stringify(readyPayload));
			_jockey2.default.send(_events2.default.ready, readyPayload, cb);
		}

		// this method is called when native send its ready payload

	}, {
		key: 'initializePayload',
		value: function initializePayload(payload, cb) {
			this.env = new Env(this, payload.env);
			this.params = new Params(this, payload.params);
			this.user = new User(this, payload.user);
			console.log('Triggering "' + _events2.default.ready + '" event from native to HTML-app!', payload);
			this.trigger(_events2.default.ready, payload, cb);
		}
	}, {
		key: 'initialize',
		value: function initialize(initPayload, cb) {
			var _this5 = this;

			this.native = true;
			if (!this.initialized) {
				var readyInitPayload = this.initializePayload.bind(this);
				_jockey2.default.on(_events2.default.player_ready, readyInitPayload);
				_jockey2.default.on(_events2.default.player_log, function (payload) {
					console.log('Sending "' + _events2.default.player_log + '" event to HTML-app!', JSON.stringify({ payload: payload }));
					_this5.trigger(_events2.default.player_log, payload);
				});
				_jockey2.default.on(_events2.default.auth_authenticate, function (payload) {
					console.log('Sending "' + _events2.default.auth_authenticate + '" event to HTML-app!', JSON.stringify({ payload: payload }));
					_this5.user = new User(_this5, payload.user);
					_this5.trigger(_events2.default.auth_authenticate, payload);
				});
				_jockey2.default.on(_events2.default.app_active, function (payload) {
					console.log('Sending "' + _events2.default.app_active + '" event to HTML-app!', JSON.stringify({ payload: payload }));
					_this5.trigger(_events2.default.app_active, payload);
				});
				_jockey2.default.on(_events2.default.app_deactive, function (payload) {
					console.log('Sending "' + _events2.default.app_deactive + '" event to HTML-app!', JSON.stringify({ payload: payload }));
					_this5.trigger(_events2.default.app_deactive, payload);
				});
				_jockey2.default.on(_events2.default.ui_trigger_notification, function (payload) {
					console.log('Sending "' + _events2.default.ui_trigger_notification + '" event to HTML-app!', JSON.stringify({ payload: payload }));
					_this5.trigger(_events2.default.ui_trigger_notification, payload);
				});
				_jockey2.default.on(_events2.default.keyboard_will_show, function (payload) {
					console.log('Sending "' + _events2.default.keyboard_will_show + '" event to HTML-app!', JSON.stringify({ payload: payload }));
					_this5.trigger(_events2.default.keyboard_will_show, payload);
				});
				_jockey2.default.on(_events2.default.keyboard_did_show, function (payload) {
					console.log('Sending "' + _events2.default.keyboard_did_show + '" event to HTML-app!', JSON.stringify({ payload: payload }));
					_this5.trigger(_events2.default.keyboard_did_show, payload);
				});
				_jockey2.default.on(_events2.default.keyboard_will_hide, function (payload) {
					console.log('Sending "' + _events2.default.keyboard_will_hide + '" event to HTML-app!', JSON.stringify({ payload: payload }));
					_this5.trigger(_events2.default.keyboard_will_hide, payload);
				});
				_jockey2.default.on(_events2.default.keyboard_did_hide, function (payload) {
					console.log('Sending "' + _events2.default.keyboard_did_hide + '" event to HTML-app!', JSON.stringify({ payload: payload }));
					_this5.trigger(_events2.default.keyboard_did_hide, payload);
				});
				_jockey2.default.on(_events2.default.ui_panel_expand, function (payload) {
					console.log('Sending "' + _events2.default.ui_panel_expand + '" event to HTML-app!', payload);
					_this5.trigger(_events2.default.ui_panel_expand, payload);
				});
				_jockey2.default.on(_events2.default.ui_panel_collapse, function (payload) {
					console.log('Sending "' + _events2.default.ui_panel_collapse + '" event to HTML-app!', payload);
					_this5.trigger(_events2.default.ui_panel_collapse, payload);
				});
				_jockey2.default.on(_events2.default.ui_panel_collapse_all, function (payload) {
					console.log('Sending "' + _events2.default.ui_panel_collapse_all + '" event to HTML-app!', payload);
					_this5.trigger(_events2.default.ui_panel_collapse_all, payload);
				});
				_jockey2.default.on(_events2.default.ui_button_hide, function (payload) {
					console.log('Sending "' + _events2.default.ui_button_hide + '" event to HTML-app!', payload);
					_this5.trigger(_events2.default.ui_button_hide, payload);
				});
				_jockey2.default.on(_events2.default.ui_button_show, function (payload) {
					console.log('Sending "' + _events2.default.ui_button_show + '" event to HTML-app!', payload);
					_this5.trigger(_events2.default.ui_button_show, payload);
				});
				_jockey2.default.on(_events2.default.device_settoken, function (payload) {
					console.log('Sending "' + _events2.default.device_settoken + '" event to HTML-app!', JSON.stringify({ payload: payload }));
					_this5.trigger(_events2.default.device_settoken, payload);
				});
				_jockey2.default.on(_events2.default.device_register, function (payload) {
					console.log('Sending "' + _events2.default.device_register + '" event to HTML-app!', JSON.stringify({ payload: payload }));
					_this5.trigger(_events2.default.device_register, payload);
				});
				_jockey2.default.on(_events2.default.device_unregister, function (payload) {
					console.log('Sending "' + _events2.default.device_unregister + '" event to HTML-app!', JSON.stringify({ payload: payload }));
					_this5.trigger(_events2.default.device_unregister, payload);
				});
				_jockey2.default.on(_events2.default.device_subscribe, function (payload) {
					console.log('Sending "' + _events2.default.device_subscribe + '" event to HTML-app!', JSON.stringify({ payload: payload }));
					_this5.trigger(_events2.default.device_subscribe, payload);
				});
				_jockey2.default.on(_events2.default.device_unsubscribe, function (payload) {
					console.log('Sending "' + _events2.default.device_unsubscribe + '" event to HTML-app!', JSON.stringify({ payload: payload }));
					_this5.trigger(_events2.default.device_unsubscribe, payload);
				});
				_jockey2.default.on(_events2.default.shoutbox_shout, function (payload) {
					console.log('Sending "' + _events2.default.shoutbox_shout + '" event to HTML-app!', JSON.stringify({ payload: payload }));
					_this5.trigger(_events2.default.shoutbox_shout, payload);
				});
				_jockey2.default.on(_events2.default.emojis_trigger, function (payload) {
					console.log('Sending "' + _events2.default.emojis_trigger + '" event to HTML-app!', JSON.stringify({ payload: payload }));
					_this5.trigger(_events2.default.emojis_trigger, payload);
				});
				_jockey2.default.on(_events2.default.avatars_trigger, function (payload) {
					console.log('Sending "' + _events2.default.avatars_trigger + '" event to HTML-app!', JSON.stringify({ payload: payload }));
					_this5.trigger(_events2.default.avatars_trigger, payload);
				});
				_jockey2.default.on(_events2.default.polls_vote, function (payload) {
					console.log('Sending "' + _events2.default.polls_vote + '" event to HTML-app!', JSON.stringify({ payload: payload }));
					_this5.trigger(_events2.default.polls_vote, payload);
				});
				_jockey2.default.on(_events2.default.quiz_answer, function (payload) {
					console.log('Sending "' + _events2.default.quiz_answer + '" event to HTML-app!', JSON.stringify({ payload: payload }));
					_this5.trigger(_events2.default.quiz_answer, payload);
				});
				_jockey2.default.on(_events2.default.quiz_question_redeem, function (payload) {
					console.log('Sending "' + _events2.default.quiz_question_redeem + '" event to HTML-app!', JSON.stringify({ payload: payload }));
					_this5.trigger(_events2.default.quiz_question_redeem, payload);
				});
				_jockey2.default.on(_events2.default.quiz_setcode, function (payload) {
					console.log('Sending "' + _events2.default.quiz_setcode + '" event to HTML-app!', payload);
					_this5.trigger(_events2.default.quiz_setcode, payload);
				});
				_jockey2.default.on(_events2.default.media_video_quality, function (payload) {
					console.log('Sending "' + _events2.default.media_video_quality + '" event to HTML-app!', payload);
					_this5.trigger(_events2.default.media_video_quality, payload);
				});
				_jockey2.default.on(_events2.default.media_unsupported, function (payload) {
					console.log('Sending "' + _events2.default.media_unsupported + '" event to HTML-app!', payload);
					_this5.trigger(_events2.default.media_unsupported, payload);
				});
				_jockey2.default.on(_events2.default.team_setcode, function (payload) {
					console.log('Sending "' + _events2.default.team_setcode + '" event to HTML-app!', payload);
					_this5.trigger(_events2.default.team_setcode, payload);
				});
				this.initialized = true;
			}
			/* eslint-disable */
			var after = function after(n, func) {
				return function () {
					if (--n < 1) {
						return func.apply(_this5);
					}
				};
			};
			/* eslint-enable */
			var collect = after(9, function () {
				cb();
			});
			this.player.ready(function () {
				if (initPayload && initPayload.target) {
					_this5.targets.init(initPayload.target, collect);
				} else {
					collect();
				}
				if (initPayload && initPayload.streams) {
					_this5.channels.init(initPayload.streams, collect);
				} else {
					collect();
				}
				if (initPayload && initPayload.stream) {
					_this5.streams.init(initPayload.stream, collect);
				} else {
					collect();
				}
				if (initPayload && initPayload.media) {
					_this5.media.init(initPayload.media, collect);
				} else {
					collect();
				}
				if (initPayload && initPayload.emojis) {
					_this5.emojis.init(initPayload.emojis, collect);
				} else {
					collect();
				}
				if (initPayload && initPayload.shoutbox) {
					_this5.shoutbox.init(initPayload.shoutbox, collect);
				} else {
					collect();
				}
				if (initPayload && initPayload.polls) {
					_this5.polls.init(initPayload.polls, collect);
				} else {
					collect();
				}
				if (initPayload && initPayload.quiz) {
					_this5.quiz.init(initPayload.quiz, collect);
				} else {
					collect();
				}
				if (initPayload && initPayload.team) {
					_this5.team.init(initPayload.quiz, collect);
				} else {
					collect();
				}
			});
		}

		// DEPRECATED: see player.fail

	}, {
		key: 'fail',
		value: function fail(failure, cb) {
			console.log('Sending "' + _events2.default.fail + '" event to native: %j', failure);
			if (this.native) {
				_jockey2.default.send(_events2.default.fail, { failure: failure }, cb);
			} else if (cb) {
				cb();
			}
		}

		// DEPRECATED: see media.init && media.update

	}, {
		key: 'update',
		value: function update(payload, cb) {
			console.log('Sending "' + _events2.default.update + '" event to native:', JSON.stringify(payload));
			if (this.native) {
				_jockey2.default.send(_events2.default.update, payload, cb);
			} else if (cb) {
				cb();
			}
		}

		// DEPRECATED: see player.send

	}, {
		key: 'send',
		value: function send(type, payload, cb) {
			console.log('Sending generic event "%j" to native: %j!', type, payload);
			if (this.native) {
				_jockey2.default.send('zender:' + type, payload, cb);
			} else if (cb) {
				cb();
			}
		}
	}]);

	return Zender;
}(Dispatcher);

exports.default = Zender;


//////////////////
// WEBPACK FOOTER
// ./node_modules/zender-js/dist/index.js
// module id = 562
// module chunks = 0